// extracted by mini-css-extract-plugin
export default {"btnCertificate":"summary_btnCertificate__6REwG","btnReceipt":"summary_btnReceipt__otYwh"};